import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import { Provider } from 'react-redux';

import { client } from '@trello/graphql';

import { useFeatureFlag } from '@trello/feature-flag-client';
import { MarkdownContext } from 'app/gamma/src/components/trello-markdown';
import { defaultStore } from 'app/gamma/src/defaultStore';
import { TrelloMarkdownWrapper } from 'app/gamma/src/util/trello-markdown-config';

const markdownWrapper = new TrelloMarkdownWrapper(defaultStore);

export const ComponentWrapper: React.FunctionComponent = ({ children }) => {
  // If this feature flag is on, we want to disable the suppression of the existing
  // global click handling code. To do this, we'll omit the `div.js-react-root`
  // wrapper below when rendering (which means clicks that occur within this content
  // will be handled by the existing global click handling code).
  const enableGlobalClickHandling = useFeatureFlag(
    'fep.enable-global-click-handling',
    false,
  );

  const content = (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <Provider store={defaultStore}>
          <MarkdownContext.Provider value={markdownWrapper}>
            {children}
          </MarkdownContext.Provider>
        </Provider>
      </ApolloHooksProvider>
    </ApolloProvider>
  );

  return enableGlobalClickHandling ? (
    content
  ) : (
    <div className="js-react-root">{content}</div>
  );
};
